export const isFieldConfig = (field: FormConfig): field is FieldConfig =>
  field.type !== 'fieldset';
